module.exports = __webpack_public_path__ + "img/2023big30.545304f0.png";